import React, { useState, useCallback, useEffect } from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import { BsTrash, BsPencil } from 'react-icons/bs';
import { pickBy } from 'lodash';
import { useModuleContext } from 'partial/wrappers/ModuleWrapper';

import Badge from 'modules/common/components/Badge';
import Pagination from 'partial/components/Pagination';
import AsyncButton from 'modules/common/components/AsyncButton';
import Table from 'partial/components/Table';
import SearchBar from 'partial/components/input/SearchBar';
import { useCreateModal } from 'partial/components/Modal';
import AddUpdate from './modals/AddUpdate';
import Delete from './modals/Delete';
import { useBannedWords } from './hooks';

function BannedWords() {
  const { setSubLabel } = useModuleContext();

  const createModal = useCreateModal();
  const [filter, setFilter] = useState({ q: '' });
  const [isLoading, list, meta] = useBannedWords(pickBy(filter));
  const addModal = useCallback(() => {
    createModal({
      content: (onClose) => <AddUpdate onClose={onClose} />,
    });
  }, [createModal]);

  const editModal = useCallback(
    (data) => {
      createModal({
        content: (onClose) => (
          <AddUpdate data={data} onClose={onClose} type="edit" />
        ),
      });
    },
    [createModal],
  );

  const deleteModal = useCallback(
    (data) => {
      createModal({
        content: (onClose) => <Delete data={data} onClose={onClose} />,
      });
    },
    [createModal],
  );

  const renderAction = (data) => (
    <div className="flex gap-1">
      <AsyncButton
        color="regular-with-border-primary"
        className="!text-xs !px-3 !py-1"
        onClick={() => deleteModal(data)}
      >
        <div className="flex gap-2 items-center !capitalize">
          <BsTrash /> Delete
        </div>
      </AsyncButton>

      <AsyncButton
        color="regular-with-border-primary"
        className="!text-xs !px-3 !py-1"
        onClick={() => editModal(data)}
      >
        <div className="flex gap-2 items-center !capitalize">
          <BsPencil /> Edit
        </div>
      </AsyncButton>
    </div>
  );

  const format = [
    {
      label: 'status',
      labelClassName: 'pl-8',
      contentClassName: 'w-[12rem]',
      key: (data) => (
        <div className="w-full">
          <Badge containerClassName="w-[60%]" status={data?.status} />
        </div>
      ),
    },
    {
      label: 'words',
      key: 'ban_word',
    },
    {
      label: 'Action',
      id: 'action',
      labelClassName: 'justify-end !pr-14',
      contentClassName: 'flex justify-end',
      key: (data) => renderAction(data),
    },
  ];

  useEffect(() => {
    if (!meta) return;
    setSubLabel(
      meta?.total === 0
        ? ''
        : `Total of ${meta?.total} banned word${meta?.total === 1 ? '' : 's'}`,
    );
    return () => setSubLabel('');
  }, [meta, setSubLabel]);

  return (
    <section className="p-6 bg-white drop-shadow rounded-lg h-full flex flex-col gap-5">
      <div className="flex items-center justify-between space-x-5">
        <SearchBar
          name="q"
          value={filter.q}
          onChange={setFilter}
          inputClassName="py-[1.05rem] "
        />

        <AsyncButton onClick={() => addModal()}>
          <div className="flex gap-2 items-center">
            <AiOutlinePlus /> add
          </div>
        </AsyncButton>
      </div>
      <div className="flex flex-col gap-10 min-h-[65vh]">
        <Table isLoading={isLoading} data={list} format={format} />
        <Pagination value={meta} onChange={setFilter} />
      </div>
    </section>
  );
}

export default BannedWords;
